<template>
    <div class="content">
      <div class="container-fluid">
        <div class="d-flex flex-wrap mt-3 equal-height-cards justify-content-between">
          <div class="flex-fill card-wrapper">
            <router-link to="/dashboard/association/types/super" style="text-decoration: none; color: inherit; height: 100%; display: block;">
            <stats-card class="h-100">
              <div slot="header" class="icon-warning">
                 <b-icon style="color: rgba(240, 206, 13, 0.937)" icon="tags" aria-hidden="true"></b-icon>
              </div>
              <div slot="content">
                <p class="card-category">{{ translate('allAssociation') }}</p>
                <h4 class="card-title">{{totalEkubTypes}}</h4>
              </div>
              <div slot="footer">
                <b-icon icon="plus" aria-hidden="true"></b-icon>
                {{ translate('total') }}
              </div>
            </stats-card>
          </router-link>
          </div>
          <div class="flex-fill card-wrapper">
            <router-link to="/dashboard/members/super" style="text-decoration: none; color: inherit; height: 100%; display: block;">
            <stats-card class="h-100">
              <div slot="header" class="icon-success">
                <b-icon style="color: rgba(240, 206, 13, 0.937)" icon="person" aria-hidden="true"></b-icon>
              </div>
              <div slot="content">
                <p class="card-category">{{ translate('allMembers') }}</p>
                <h4 class="card-title">{{totalEkubMembers}}</h4>
              </div>
              <div slot="footer">
                <b-icon icon="plus" aria-hidden="true"></b-icon>
                {{ translate('total') }}
              </div>
            </stats-card>
          </router-link>
          </div>
  
          <div class="flex-fill card-wrapper">
            <router-link to="/dashboard/payments/super" style="text-decoration: none; color: inherit; height: 100%; display: block;">
            <stats-card class="h-100">
              <div slot="header" class="icon-info">
                <b-icon style="color: rgb(37, 91, 48)" icon="cash" aria-hidden="true"></b-icon>
              </div>
              <div slot="content">
                <p class="card-category">{{ translate('totalPaid') }}</p>
                <h4 class="card-title">{{numberWithCommas(totalPaid)}}</h4>
                <p class="card-category">{{ translate('ServiceFee') }}{{numberWithCommas(serviceFee)}}</p>
              </div>
              <div slot="footer">
                <b-icon icon="calendar2" aria-hidden="true"></b-icon>{{ translate('thisMonth') }}
              </div>
            </stats-card>
          </router-link>
          </div>
  
          <div class="flex-fill card-wrapper">
            <stats-card class="h-100">
              <div slot="header" class="icon-danger">
                <b-icon style="color: #FB404B;" icon="exclamation-octagon" aria-hidden="true"></b-icon>
              </div>
              <div slot="content">
                <p class="card-category">{{ translate('totalUnpaid') }}</p>
                <h4 class="card-title">{{numberWithCommas(totalUnpaid)}}</h4>
              </div>
              <div slot="footer">
                <b-icon icon="calendar2" aria-hidden="true"></b-icon>{{ translate('thisMonthAndPassed') }}
              </div>
            </stats-card>
          </div>

          <div class="flex-fill card-wrapper">
            <stats-card class="h-100">
              <div slot="header" class="icon-primary">
                <b-icon style="color: #007bff;" icon="collection" aria-hidden="true"></b-icon>
              </div>
              <div slot="content">
                <p class="card-category">Equb Collected By Tsehay</p>
                <h4 class="card-title">{{numberWithCommas(tsehayContributionAmount)}}</h4>
                <p class="card-category">Service Fee: {{numberWithCommas(tsehayServiceAmount)}}</p>
              </div>
              <div slot="footer">
                <b-icon icon="cash-stack" aria-hidden="true"></b-icon>Total Collected
              </div>
            </stats-card>
          </div>
  
        </div>
        <div class="row">
          <div class="col-md-4" >
            <b-card style="display: flex; justify-content: center; align-items: center;">
              <apexchart width="500" type="pie" :options="pieChart.chartOptions" :series="pieChart.series"></apexchart>
            </b-card>
          </div>
          <div class="col-md-8">
            <b-card style="display: flex; justify-content: center; align-items: center;">
              <div class="row" style="display: flex; justify-content: end; align-items: end;">
                <b-form-select style="width: 20%;" v-model="currentYear" :options="yearOptions" size="sm" @change="getMonthlyTotalIncome()" class="mt-3"></b-form-select>
              </div>
              <div class="row">
                <apexchart width="700" height="350" type="bar" :options="barChart.chartOptions" :series="barChart.series"></apexchart>
              </div>
            </b-card>
          </div>
        </div>
   </div>
    </div>
  </template>
  <script>
    import ChartCard from 'src/components/Cards/ChartCard.vue'
    import StatsCard from 'src/components/Cards/StatsCard.vue'
    import LTable from 'src/components/Table.vue'
    import { setLanguage, translate } from 'src/i18n.js';
    export default {
      components: {
        LTable,
        ChartCard,
        StatsCard
      },
      data () {
        return {
          pieChart:{
            chartOptions: {
              chart: {
                id: "apexchart-example",
              },
              title: {
                text: translate('statistics'),
                align: "center",
                style: {
                  fontSize: "20px",
                  fontWeight: "400",
                  color: "#9A9A9A",
                },
              },
              colors: [],
              dataLabels: {
                enabled: true,
              },
              legend: {
                show: true,
                position: 'bottom',
              },
                labels: [],
            },
            series: [],
          },
          barChart:{
            chartOptions: {
              chart: {
                id: 'vuechart-example'
              },
              title: {
                text: translate('thisYearRevenue'),
                align: "center",
                margin: 40,
                style: {
                  fontSize: "20px",
                  fontWeight: "400",
                  color: "#9A9A9A",
                },
              },
              xaxis: {
                categories: [translate('jan'),translate('feb'),translate('mar'),translate('apr'),translate('may'),translate('jun'),translate('jul'),translate('aug'),translate('sep'),translate('oct'),translate('nov'),translate('dec')]
              },
              colors: ['#255b30','#255b30','#255b30','#255b30','#255b30','#255b30','#255b30','#255b30','#255b30','#255b30','#255b30','#255b30']
            },
            series: [{
              name: 'series-1',
              data: [0,0,0,0,0,0,0,0,0,0,0,0]
            }]
          },
          totalRevenueExpected: 0,
          totalPaid: 0,
          serviceFee: 0,
          totalUnpaid: 0,
          totalOverdue: 0,
          totalEkubTypes: 0,
          totalEkubMembers: 0,
          tsehayTotal: 0,
          tsehayContributionAmount: 0,
          tsehayServiceAmount: 0,
          editTooltip: 'Edit Task',
          deleteTooltip: 'Remove',
          currentYear: null,
          yearOptions: [
            { text: "2022", value: 2022},
            { text: "2023", value: 2023},
            { text: "2024", value: 2024},
            { text: "2025", value: 2025},
            { text: "2026", value: 2026},
            { text: "2027", value: 2027},
            { text: "2028", value: 2028},
            { text: "2029", value: 2029},
            { text: "2030", value: 2030},
            { text: "2031", value: 2031},
            { text: "2032", value: 2032}
          ],
          spin: false,
        }
      },
      beforeMount() {
        
      },
      mounted() {
        this.getPaidAmountAndList();
        this.getAllCountAssociationForSuper();
        this.getAllCountMemberForSuper();
        this.getMonthlyTotalIncome();
        this.getUnPaidAmountAndList();
        this.getTsehayCollectionAmounts();
        // window.location.reload();
      },
      computed: {
  
      },
      watch: {
  
      },
      methods: {
        translate,
      changeLanguage(lang) {
        setLanguage(lang);
        this.$forceUpdate();
      },
        async getPaidAmountAndList(){
           await this.$store.dispatch('getPaidAmountAndListForSuper', {userId: sessionStorage.getItem("ID"),superUserId: parseInt(sessionStorage.getItem("superID"))})
            .then(response=>{
              
                this.totalPaid = response.data.totalPaid;
                this.serviceFee = response.data.serviceFee;
                this.totalRevenueExpected += this.totalPaid;
                this.pieChart.chartOptions.colors.push('#255b30');
                this.pieChart.chartOptions.labels.push(translate('paid'));
                this.pieChart.series.push(this.totalPaid);
                //console.log("total:", response.data);
            })
            .catch(error=>{
                // this.$notify({
                //     title: 'Error',
                //     text: error.response.data,
                //     type: 'error'
                // })
                console.log(error);
            })
        },
        async getUnPaidAmountAndList(){
          await this.$store.dispatch('getUnPaidAmountAndListForSuper', {userId: sessionStorage.getItem("ID"),superUserId: parseInt(sessionStorage.getItem("superID"))})
            .then(response=>{
              // console.log("totalUnpaid",response.data);
                this.totalUnpaid = response.data.totalUnpaid;
                this.totalRevenueExpected += this.totalUnpaid;
                this.pieChart.chartOptions.colors.push('#FB404B');
                this.pieChart.chartOptions.labels.push(translate('unpaid'));
                this.pieChart.series.push(this.totalUnpaid);
                
            })
            .catch(error=>{
              //console.log("totalUnpaid:", error);
                // this.$notify({
                //     title: 'Error',
                //     text: error.response.data,
                //     type: 'error'
                // })
                console.log(error);
            })
        },
        getAllCountAssociationForSuper(){
           this.$store.dispatch('getAllCountAssociationForSuper', {userId: sessionStorage.getItem("ID"),superUserId: parseInt(sessionStorage.getItem("superID"))})
            .then(response=>{
                this.totalEkubTypes = response.data;
            })
            .catch(error=>{
                // this.$notify({
                //     title: 'Error',
                //     text: error.response.data,
                //     type: 'error'
                // })
                console.log(error);
            })
        },
        getAllCountMemberForSuper(){
           this.$store.dispatch('getAllCountMemberForSuper', {userId: sessionStorage.getItem("ID"),superUserId: parseInt(sessionStorage.getItem("superID"))})
            .then(response=>{
                this.totalEkubMembers = response.data;
                // console.log("item:", response.data)
            })
            .catch(error=>{
                // this.$notify({
                //     title: 'Error',
                //     text: error.response.data,
                //     type: 'error'
                // })
                console.log(error);
            })
        },
        getMonthlyTotalIncome(){
          this.spin = true;
          this.barChart.series[0].data=[];
          window.dispatchEvent(new Event('resize')) 
          if(this.currentYear == null){
            var date = new Date().getFullYear();
    
            this.currentYear = date;
          }
  
          this.$store.dispatch('getMonthlyTotalIncomeForSuper', {"userId": sessionStorage.getItem("ID"),superUserId: parseInt(sessionStorage.getItem("superID")),"whichYear": this.currentYear })
            .then(response=>{
              //console.log("month", response.data)
                var month = [];
                month.push(response.data.perMonth.Jan);
                month.push(response.data.perMonth.Feb);
                month.push(response.data.perMonth.Mar);
                month.push(response.data.perMonth.Apr);
                month.push(response.data.perMonth.May);
                month.push(response.data.perMonth.Jun);
                month.push(response.data.perMonth.Jul);
                month.push(response.data.perMonth.Aug);
                month.push(response.data.perMonth.Sep);
                month.push(response.data.perMonth.Oct);
                month.push(response.data.perMonth.Nov);
                month.push(response.data.perMonth.Dec);
                this.barChart.series[0].data=month;
                window.dispatchEvent(new Event('resize')) 
               // console.log("monthBar", this.barChart.series[0].data);
            })
            .catch(error=>{
              this.barChart.series[0].data = [];
                this.$notifications.notify({
                  message: error.response.data,
                  horizontalAlign: 'center',
                  verticalAlign: 'top',
                  type: 'danger'
                })
                console.log(error);
            })
            .finally(msg=>{
               this.spin = false;
            })
        },
        numberWithCommas(x) {
          if(x !== null && x !== undefined){
              x = x.toFixed(2);
              return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
          }
        },
        getTsehayCollectionAmounts(){
        this.$store.dispatch('calculateAmountCollectedByTsehay', {userId: parseInt(sessionStorage.getItem("superID"))})
            .then(response=>{
              this.tsehayContributionAmount = response.data.contributionAmount;
              this.tsehayServiceAmount = response.data.serviceAmount;
              this.tsehayTotal = response.data.total;
            })
            .catch(error=>{
              console.log(error);
            })
        },
      }
    }
  </script>
  <style>
   .ct-series-b .ct-slice-pie, .ct-series-b .ct-area {
      fill: rgba(240, 206, 13, 0.973);
    }
  
    .ct-series-a .ct-slice-pie, .ct-series-a .ct-area {
      fill: rgb(37, 91, 48, 0.6);
    }
    .ct-series-c .ct-slice-pie, .ct-series-c .ct-area {
      fill: #FB404B !important;
    }
    .ct-series-a .ct-bar{
      stroke: rgba(240, 206, 13, 0.973);
    }
    
    .equal-height-cards .card-wrapper {
      margin: 0 5px 15px 5px;
      min-width: 200px;
    }
    
    .equal-height-cards .stats-card {
      height: 100%;
      display: flex;
      flex-direction: column;
    }
    
    .equal-height-cards .card {
      height: 100%;
    }
    
    @media (max-width: 1200px) {
      .equal-height-cards {
        justify-content: center;
      }
      .equal-height-cards .card-wrapper {
        flex: 0 0 calc(33.333% - 10px);
      }
    }
    
    @media (max-width: 768px) {
      .equal-height-cards .card-wrapper {
        flex: 0 0 calc(50% - 10px);
      }
    }
    
    @media (max-width: 576px) {
      .equal-height-cards .card-wrapper {
        flex: 0 0 100%;
        margin: 0 0 15px 0;
      }
    }
    
    @media (max-width: 500px) {
      #vuechart-example{
        width: 250px;
        height: 200px;
      }
    }
  </style>
  